module.exports = __webpack_public_path__ + "img/unblankingIcon.abffb35c.png";